import { Stack, Typography, DoctorCard, Receipt } from "components";
import { AppointmentType, Doctor } from "types";
import CheckoutLoader from "./CheckoutLoader";

const TITLES = {
  now: "Consult now with",
  later: "Consult later with",
};

type AppointmentSummaryProps = {
  type: AppointmentType;
  doctor?: Doctor;
  table: string[][][];
};

const AppointmentSummary: React.FC<AppointmentSummaryProps> = ({
  type,
  doctor,
  table,
}) => {
  const doctorCardStyle = {
    gap: "12px",
    padding: "10px 16px",
    margin: "0 -16px",
    background: "#e3f2fd",
  };

  return (
    <Stack direction="column" gap={2}>
      <Typography>{TITLES[type]}</Typography>

      {doctor ? (
        <DoctorCard
          name={doctor.displayName}
          premium={doctor.isPremium}
          price={{ amount: doctor.price, size: 1 }}
          avatar={{ image: doctor.image, size: "32px" }}
          style={doctorCardStyle}
        />
      ) : (
        <CheckoutLoader />
      )}

      <Stack direction="column">
        <Receipt items={table} labelStyle={{ flex: 1 }} size={-1} />
      </Stack>
    </Stack>
  );
};

export default AppointmentSummary;
